import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faSave, faUpload, faTimes, faFilePdf, faPlay, faHourglass, faLifeRing } from '@fortawesome/free-solid-svg-icons'
import { convertTemplateCode } from '../../template/converters'
import { updateTemplate, createTemplate } from '../../template/actions'
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

class DashboardMenu extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
    };
  }

  handleUploadClick = (e) => {
    this.uploadRef.click()
  }

  handleUploadTemplateClick = (e) => {
    if (!this.props.isTemplateModified || window.confirm("Are you sure you want to discard the current template?")) {
      this.uploadTemplateRef.click()
    }
  }

  handleSaveClick = (redirectAfterSave = false) => {
    try {
      const jsonTemplate = convertTemplateCode(this.props.template)
      if (this.props.templateId == null) {
        this.props.createTemplate(jsonTemplate, redirectAfterSave)
      } else {
        this.props.updateTemplate(this.props.templateId, jsonTemplate, jsonTemplate.templateName)
      }
    } catch (err) {
      this.setState({
        syntaxError: true,
        syntaxErrorMessage: err,
        copied: false
      })
    }
  }

  handleSaveExitClick = () => {
    this.props.disableUnloadAlert()
    this.handleSaveClick(true)
  }

  handleDiscardChangesClick = () => {
    if (!this.props.isTemplateModified || window.confirm("Are you sure you want to discard all changes in the current template?")) {
      this.props.disableUnloadAlert()
      window.location.assign(process.env.REACT_APP_DOCPARSER_TEMPLATE_EDITOR_UPDATE_TEMPLATE_REDIRECT)
    }
  }

  handleClickRunTemplate = () => {
    if (this.props.isCustomFile) {
      this.props.handleRunTemplate()
    }
    else {
      if (window.confirm("No PDF file is loaded for testing. Do you want to load PDF file now?")) {
        this.uploadRef.click()
      }
    }
  }

  renderTooltip = (name, id, props) => (
    <Tooltip id={id} {...props} className="tooltip-btn">
      {name}
    </Tooltip>
  );

  render() {
    return (
      <div className="input-group dashboard-menu pB-10">
        <div className="container-fluid">
          <div className="header-buttons">
            <div>

              {/*<div className="d-inline-block mT-10 mR-10" style={{ verticalAlign: 'middle' }}>*/}
              {/*  <Dropdown drop="down">*/}
              {/*    <OverlayTrigger   placement="top"*/}
              {/*                      delay={{ show: 250, hide: 400 }}*/}
              {/*                      overlay={(props) => this.renderTooltip("Sample Templates", "sample_templates_id", props)}>*/}
              {/*      <Dropdown.Toggle variant="success" id="dropdown-basic" disabled={this.props.isRunningTemplate}>*/}
              {/*        <FontAwesomeIcon icon={faLifeRing} /> Sample Templates &nbsp;*/}
              {/*      </Dropdown.Toggle>*/}
              {/*    </OverlayTrigger>*/}

              {/*  <Dropdown.Menu*/}
              {/*    className="dropdown-multicol"*/}
              {/*  >*/}
              {/*    <div className="dropdown-row">                  */}
              {/*      {SampleTemplateOptions.map(option => (*/}
              {/*        <Dropdown.Item */}
              {/*          onClick={e => this.handleClickLoadSample(option)} */}
              {/*          key={option.label}>{option.label}*/}
              {/*        </Dropdown.Item>*/}
              {/*      ))}*/}
              {/*    </div>*/}

              {/*  </Dropdown.Menu>*/}
              {/*  */}
              {/*</Dropdown>*/}
              {/*</div>*/}

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Create or Open Template from templates library", "template_library_id", props)}>
                <button disabled={this.props.isRunningTemplate} className="btn btn-success mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Create or Open Template" onClick={this.props.handleOpenSampleTemplate}>
                  <FontAwesomeIcon icon={faFile} /> Create or Open Template
                </button>
              </OverlayTrigger>
  

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Load Test PDF or Image", "load_test_pdf_or_image_id", props)}>
              <button disabled={this.props.isRunningTemplate} className="btn btn-outline-secondary mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Load test PDF document that you will use to test your template" onClick={this.handleUploadClick}>
                <FontAwesomeIcon icon={faFilePdf} /> Load Test PDF or Image
              </button>
              </OverlayTrigger>

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}

                                overlay={(props) => this.renderTooltip("Edit Raw Template Code", "edit_raw_template", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-secondary mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Edit Raw Template" onClick={this.props.handleEditClick}>
                <FontAwesomeIcon icon={faSave} /> Edit Raw Template
              </button>
              </OverlayTrigger>

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Run Template", "run_template_id", props)}>
              <button disabled={this.props.isRunningTemplate} className="btn btn-warning mR-10 mT-10" data-toggle="tooltip" data-placement="bottom" title="Run template" onClick={this.handleClickRunTemplate}>
                {this.props.isRunningTemplate ? <FontAwesomeIcon icon={faHourglass} /> : <FontAwesomeIcon icon={faPlay} />} <strong>Run Template</strong>
              </button>
              
              </OverlayTrigger>


              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Discard and Return", "discard_and_return_id", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-danger mR-10 mL-20 mT-10 pull-right" data-toggle="tooltip" data-placement="bottom" title="Discard template changes" onClick={this.handleDiscardChangesClick}>
                <FontAwesomeIcon icon={faTimes} /> Discard and Return
              </button>
              </OverlayTrigger>

              <OverlayTrigger   placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={(props) => this.renderTooltip("Save Template and Return", "save_template_and_return_id", props)}>
              <button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-success mR-10 mL-20 mT-10 pull-right" data-toggle="tooltip" data-placement="bottom" title="Save template" onClick={this.handleSaveExitClick}>
                <FontAwesomeIcon icon={faSave} /> Save Template and Return
              </button>
              </OverlayTrigger>

              {/*<button disabled={!this.props.fileUploaded || this.props.isRunningTemplate} className="btn btn-success mR-10 mT-10 pull-right" data-toggle="tooltip" data-placement="bottom" title="Save template" onClick={this.handleSaveClick}>*/}
              {/*  <FontAwesomeIcon icon={faSave} /> Save Template*/}
              {/*</button>*/}

            </div>

            <OverlayTrigger   placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={(props) => this.renderTooltip("Document Classifier", "document_classifier_id", props)}>
            <div className="external-buttons">
              <a href="/document-classifier" target="_blank">
                <button disabled={this.props.isRunningTemplate} className="btn btn-warning mR-10 mt-2 document-classifier-btn" data-toggle="tooltip" data-placement="bottom" title="Document Classifier" onClick={this.props.resetTemplate}>
                  Document Classifier
                </button>
              </a>
            </div>
            </OverlayTrigger>
          </div>
        </div>

        <div className="custom-file hidden">
          <input ref={(ref) => this.uploadRef = ref} type="file" className="form-control" accept="application/pdf,image/jpeg,image/png" id="uploadPdf" onChange={(e) => this.props.handleFileUploaded(e.target.files)} />
          <label className="custom-file-label ta-left" htmlFor="uploadPdf">{this.props.fileName}</label>
        </div>

      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
    templateId: state.templateId
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateTemplate,
    createTemplate
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardMenu)
